import {Modal} from "react-bootstrap";
import {store} from "../../../store";
import {closeListModal} from "../../../slices/listModalSlice";
import ListForm from "../../../forms/listForm";
import {animeListsApi, useAddListMutation} from "../../../api/store/anime-lists";
import {useDispatch} from "react-redux";

const AddListModal = ({isOpen = false,  onClose = () => {}}) => {
    const [addList, {
        isLoading: isAdding
    }] = useAddListMutation();

    const dispatch = useDispatch();

    const handleSubmit = (body: any) => {
        addList(body)
            .then(() => {
            dispatch(animeListsApi.util.invalidateTags(["AnimeLists"]));
            onClose();
            store.dispatch(closeListModal());
        })
    }

    return (
        <Modal
            show={isOpen}
            onHide={() => {
                store.dispatch(closeListModal());
                onClose();
            }}
            scrollable={true}
            id="listModal"
        >
            <Modal.Header closeButton>
                <Modal.Title>Add list</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ListForm
                    submitButtonText="Add"
                    onSubmit={handleSubmit}
                    isSubmitting={isAdding}
                />
            </Modal.Body>
        </Modal>
    )
}

export default AddListModal;
